/**
 * GlobalLoader component displays a full-screen loading overlay.
 * Used during session initialization or major app-level loading states.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.active - Whether loader is active/visible
 * @returns {React.ReactElement|null} Global loader or null if not active
 */
export default function GlobalLoader({ active }) {
  // Guard: Don't render if not active
  if (!active) {
    return null
  }

  return (
    <div className="global-loader" aria-live="polite" aria-busy="true">
      <div className="global-loader__content">
        <div className="global-loader__spinner" aria-hidden="true"></div>
        <p className="global-loader__text">Ładowanie...</p>
      </div>
    </div>
  )
}
